/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getQuoteRequestComments } from "api/services/quoteRequest";
import { quoteRequestQueryKeys } from "./quoteRequestQueryKeys";

export const useGetQuoteRequestComments = (shipmentId: string, options: UseQueryOptions) =>
  useQuery({
    queryKey: quoteRequestQueryKeys.quoteCommentsListing(shipmentId),
    queryFn: () => getQuoteRequestComments(shipmentId).then((res) => res.data),
    ...options,
  });
